import React, { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import CONTENT from '@/constants/content'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import { IMediaCard } from '@pcln/contentful-components'
import MediaCardComponent from '../MediaCard/MediaCardComponent'
import mediaCardContentsFallback from './content'

export default function VIP() {
  const {
    customer: { firstName }
  } = useContext(BootstrapDataContext)

  const promo = useContentfulVariation<IMediaCard>('leftPromoBox')
  const hasContentfulData = promo != null

  const headlineVIP = firstName
    ? CONTENT.homepage.vip.promo.headlineWithName.replace(
        '{firstName}',
        firstName
      )
    : CONTENT.homepage.vip.promo.headline

  mediaCardContentsFallback.heading = headlineVIP
  const mediaCardContent = hasContentfulData ? promo : mediaCardContentsFallback

  return <MediaCardComponent content={mediaCardContent} />
}
